import React, { useContext } from "react";
import "./text.css";
import { Trans, useTranslation } from "react-i18next";
import { Context } from "./Store2.js";

export default function ExplainText() {
    const [state, setState] = useContext(Context);
    const { t, i18n } = useTranslation();
    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setState({ language: language });
    };
    return (
        <div>
            <h2>
                <Trans i18nKey="explain_text.title" />
            </h2>
            <article id="explain_text">
                <p>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t("explain_text.part1"),
                        }}
                    />
                </p>
                <p>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t("explain_text.part2"),
                        }}
                    />
                </p>
                <p>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t("explain_text.part3"),
                        }}
                    />
                </p>
                <p>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t("explain_text.part4"),
                        }}
                    />
                </p>
                <p>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t("explain_text.part5"),
                        }}
                    />
                </p>
                <p>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t("explain_text.part6"),
                        }}
                    />
                </p>
                <p>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t("explain_text.part7"),
                        }}
                    />
                </p>
                <p>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t("explain_text.part8"),
                        }}
                    />
                </p>
            </article>
        </div>
    );
}
